export default {
    ActivityDetails: {
        title: "活动预约记录",
        search: "查询",
        txId: "预约ID",
        account: "会员账号",
        contact: "联系信息",
        peopleNumber: "人数",
        dateStr: "预定日期",
        timeNo: "预定时间",
        pointsNumber: "支付积分",
        status: "状态",
        statusValid: "有效",
        statusCancel: "已取消",
        remark: "特殊吩咐",
        adminRemark: "后台备注",
        cTime: "预约时间",
        action: "操作",
        editRemark: "编辑后台备注",
        remarkDialogTitle: "编辑后台备注",
        remarkPlaceholder: "请输入后台备注内容",
        cancel: "取消",
        save: "保存",
        emptyRemark: "备注不能为空",
        saveSuccess: "保存成功",
        roomTitle: "房间预约记录",
        productTitle: "产品预约记录",
        store: "门店",
    },
    WalletList: {
        title: "钱包积分交易记录",
        accountPlaceholder: "请输入会员账号",
        txId: "记录ID",
        type: "类型",
        typeRecharge: "充值",
        typeDeduct: "扣除",
        typeFood: "餐饮",
        value: "金额",
        amount: "积分",
        url: "凭据",
        view: "查看",
        remark: "备注",
        operator: "操作人",
        createTime: "创建时间",
        action: "操作",
        editRemark: "备注",
        remarkDialogTitle: "编辑备注",
        remarkPlaceholder: "请输入备注内容",
        cancel: "取消",
        save: "保存",
        search: "查询",
        emptyRemark: "备注不能为空",
        saveSuccess: "保存成功",
        admin_remark: "后台备注",
    },
    ReserveList: {
        title: "产品约看管理",
        accountPlaceholder: "请输入会员账号",
        txId: "约看ID",
        account: "会员账号",
        contact: "联系信息",
        serialNumber: "产品编号",
        location: "约看地点",
        reserveDate: "约看时间",
        remark: "特殊吩咐",
        createTime: "预约时间",
        status: "状态",
        valid: "有效",
        cancelled: "已取消",
        action: "操作",
        editRemark: "备注",
        remarkDialogTitle: "添加备注",
        remarkPlaceholder: "请输入备注内容",
        cancel: "取消",
        save: "保存",
        search: "查询",
        emptyRemark: "备注不能为空",
        saveSuccess: "保存成功",
    },
    SystemSetting: {
        title: "系统设置",
        wechat: "微信联系信息",
        whatsapp: "WhatsApp 联系信息",
        name: "姓名",
        number: "微信号/号码",
        position: "职位",
        message: "消息模板",
        avatar: "头像",
        qrcode: "二维码",
        uploadAvatar: "上传头像",
        uploadQRCode: "上传二维码",
        save: "保存",
        saveSuccess: "保存成功",
        saveFailed: "保存失败",
        uploadSuccess: "上传成功",
        uploadFailed: "上传失败",
        contact: "联系方式"
    },
    ProductManage: {
        title: "产品管理",
        addProduct: "新增产品",
        editProduct: "编辑产品",
        titleCH: "产品名称（中文）",
        titleEN: "产品名称（英文）",
        coverCH: "封面（中文）",
        coverEN: "封面（英文）",
        detailsCH: "详情图(中文)",
        detailsEN: "详情图(英文)",
        summaryCH: "简介(中文)",
        summaryEN: "简介(英文)",
        colorCH: "颜色（中文）",
        colorEN: "颜色（英文）",
        materialCH: "材料（中文）",
        materialEN: "材料（英文）",
        locationCH: "位置（中文）",
        locationEN: "位置（英文）",
        serialNumber: "序列号",
        price: "价格",
        operator: "操作人",
        createTime: "创建时间",
        status: "状态",
        contentCH: '详情(中文)',
        contentEN: '详情(英文)',
    },
    RoomManage: {
        title: "房间管理",
        addRoom: "新增房间",
        editRoom: "编辑房间",
        nameCH: "房间名称（中文）",
        nameEN: "房间名称（英文）",
        coverCH: "中文封面",
        coverEN: "英文封面",
        menus: "菜单列表",
        operator: "操作人",
        createTime: "创建时间",
        menuNameCH: "菜单中文名称",
        menuNameEN: "菜单英文名称",
        addMenuBlock: "新增菜单",
        delete: '删除菜单',
        needCoverCH: "请上传中文封面",
        needCoverEN: "请上传英文封面",
        needOneMenu: "至少需要一个菜单块",
        needMenuNameCH: "请填写菜单中文名称",
        needMenuNameEN: "请填写菜单英文名称",
        needMenuImage: "每个菜单至少上传一张图片",
        completeRequired: "请先完成必填项",
    },
    MemberActivity: {
        title: "活动管理",
        addActivity: "新增活动",
        editActivity: "编辑活动",
        type: "活动类型",
        typeText: "文案活动",
        typeNormal: "普通活动",
        typeFood: "餐饮活动",
        title_ch: "中文标题",
        title_en: "英文标题",
        summary_ch: "中文摘要",
        summary_en: "英文摘要",
        content_ch: "中文内容",
        content_en: "英文内容",
        cover_ch: "中文封面链接",
        cover_en: "英文封面链接",
        start_date: "开始日期",
        end_date: "结束日期",
        max_people: "每天最多报名人数",
        points: "报名所需积分",
        contact: "联系方式",
        location: "活动地点",
        menus_amount: "菜单菜品数量",
        menus_price: "菜单价格",
        menus: "菜单内容",
        menusPlaceholder: "一行一个菜品名称",
        status: "状态",
        statusSaved: "已保存",
        statusPublish: "已发布",
        statusUnpublish: "已下架",
        createTime: "创建时间",
        operator: "操作人",
        operate: "操作",
        edit: "编辑",
        publish: "发布",
        unpublish: "下架",
        cancel: "取消",
        confirm: "确定",
        modifyStatus: "修改状态",
        addSuccess: "新增成功",
        editSuccess: "编辑成功",
        publishSuccess: "发布成功",
        unpublishSuccess: "下架成功",
        operateSuccess: "操作成功",
        operateFail: "操作失败",
        UploadedFile: "已上传文件",
        LianXiRen: "联系人",
        phonePlaceholder: "请输入国家码+手机号，例如 +86 13800000000",
        PleaseEnterContent: '请输入内容',
        reservations: '查看预约',
    },
    MemberBanner: {
        title: '横幅管理',
        addBanner: '新增横幅',
        editBanner: '编辑横幅',
        type: '类型',
        typeVideo: '视频',
        typeText: '文案',
        typeLink: '文件',
        url: '文件',
        status: '状态',
        statusSaved: '保存',
        statusPublish: '发布',
        statusUnpublish: '下架',
        operate: '操作',
        edit: '编辑',
        modifyStatus: '修改状态',
        confirm: '确定',
        cancel: '取消',
        addSuccess: '新增成功',
        editSuccess: '编辑成功',
        operateSuccess: '操作成功',
        createTime: '创建时间',
        operator: '操作人',
        uploadProgress: "上传中...",
        uploadText: "上传文件",
        publish: "发布",
        unpublish: "下架",
        file: '文件',
        typeImage: "图片",
        uploadSuccess: "上传成功",
        uploadFail: "上传失败",
        deleteConfirm: "确定要删除该文件吗？",
        publishSuccess: "横幅发布成功",
        unpublishSuccess: "横幅取消发布成功",
        operateFail: "操作失败，请重试",
        delete: '删除',
        uploadTooLarge: "图片不能超过10MB",
    },
    MainHeader: {
        chinese: "中文",
        english: "英文",
        confirm: "确认",
        cancel: "取消",
        tip: "提示",
        logoutConfirm: "是否确认退出登录？",
        logout: "退出登录",
        username: "用户名",
    },
    MainAside: {
        userList: "用户列表",
        ngpLockdown: "封控列表",
        systemUserManage: "系统用户管理",
        systemUser: "系统用户",
        rights: "权限",
    },



    Login: {
        username: "用户名",
        password: "密码",
        login: "登陆",
        scanQRCode: "请使用Google Authenticator APP扫描二维码",
        nextStep: "下一步",
        enterGoogleCode: "请输入您的6位数Google令牌，用来登录",
        googleCode: "6位数验证码",
        confirm: "确认",
        enterUsername: "请输入用户名",
        enterPassword: "请输入密码",
    },
    NgpLockdownList: {
        title: "封控列表",
        ipBlock: "IP封控",
        userBlock: "用户封控",
        blockContent: "封控内容",
        search: "搜索",
        clear: "清空",
        action: "操作",
        unblock: "解封",
        confirmUnblock: "确认解封？",
        tip: "提示",
        confirm: "确认",
        cancel: "取消",
        unblockSuccess: "解封成功"
    },

    common: {
        confirm: "确定",
        cancel: "取消",
        tip: "提示",
        refresh: "刷新",
        actions: "操作",
        success: "操作成功",
        error: "请求失败",
    },


    authorize: {
        title: "授权（{name}）",
        selectAll: "全选",
        clear: "清空",
        save: "保存",
        success: "授权成功！",
        viewList: "查看列表",
        viewDetails: "查看详情",
        addOrEdit: "新增/编辑",
        publishOrOff: "发布/下架",
        operate: "操作",
        edit: "编辑",
        editRemark: "修改备注",
        createUser: "创建用户",
        freezeUser: "冻结用户",
        editUserInfo: "修改用户信息",
        manualRecharge: "手动充值",
        manualDeduct: "手动扣除",
        viewReserve: "查看预约",

        userList: "用户列表",
        setAssociate: "设置/取消关联账号",
        unblockUser: "解封用户",
        download: "下载",
        freeze: "冻结/解冻",
        orgChart: "组织图",

        ngpLockList: "封控列表",
        unblock: "解封",
        systemSettings: "系统设置",
        systemUser: "系统用户管理",
        systemUserList: "系统用户",
        rights: "权限",

        CreateAndEdit: "创建/编辑",
        operation: "上架/下架",

        // 新增模块
        bannerManagement: "横幅管理",
        activityManagement: "活动管理",
        roomManagement: "房间管理",
        productManagement: "产品管理",
        productReservation: "产品约看管理",
        walletRecords: "钱包交易记录",
        systemSetting: "系统设置",
        rightsManagement: "权限管理",
    },

    RightsManagement: {
        pageTitle: "权限",
        addPermission: "添加权限",
        editPermission: "编辑权限",
        table: {
            title: "标题",
            desc: "描述",
            createTime: "创建时间",
            status: "状态",
            operation: "操作",
            enabled: "启用",
            disabled: "禁用",
            authorize: "授权",
            edit: "编辑",
            delete: "删除",
        },
        dialog: {
            addTitle: "添加权限",
            editTitle: "编辑权限",
            labelTitle: "标题",
            labelDesc: "描述",
            titlePlaceholder: "标题",
            descPlaceholder: "选填",
            confirm: "确认",
            cancel: "取消",
        },
        confirm: {
            enable: "请确认是否启用！",
            disable: "请确认是否禁用！",
            delete: "请确认是否删除！",
        },
        message: {
            operationSuccess: "操作成功！",
            deleteSuccess: "删除成功",
            addSuccess: "添加成功",
            editSuccess: "编辑成功",
        },
        buttons: {
            confirm: "确认",
            cancel: "取消",
        },
        warning: "警告",
    },
    SystemUser: {
        pageTitle: "系统用户",
        addUser: "添加用户",
        dialog: {
            addTitle: "添加用户",
            editTitle: "编辑用户",
            username: "用户名",
            usernamePlaceholder: "邮箱格式",
            password: "密码",
            passwordPlaceholder: "密码必须包含大小写字母、数字和特殊字符，8-18位",
            auth: "权限",
            authPlaceholder: "请选择权限",
            desc: "描述",
            descPlaceholder: "选填",
            confirm: "确认",
            cancel: "取消",
            confirmTitle: "提示"
        },
        table: {
            username: "用户账号",
            authTitle: "权限标题",
            desc: "描述",
            createTime: "创建时间",
            loginTime: "登陆时间",
            status: "状态",
            enabled: "启用",
            disabled: "禁用",
            googleToken: "谷歌令牌",
            bound: "已绑定",
            unbound: "未绑定",
            blockStatus: "封禁状态",
            blocked: "封禁",
            normal: "正常",
            operation: "操作",
            edit: "编辑",
            delete: "删除",
            disable: "禁用",
            enable: "启用",
            unbind: "解绑",
            unblock: "解封"
        },
        confirm: {
            delete: "请确认是否删除！",
            disable: "请确认是否禁用！",
            enable: "请确认是否启用！",
            unblock: "是否确认解除该系统用户封停?",
            unbind: "请确认是否解绑！"
        },
        message: {
            addSuccess: "添加成功！",
            editSuccess: "编辑成功",
            deleteSuccess: "删除成功",
            unblockSuccess: "解封成功！",
            unbindSuccess: "解绑成功！",
            operationSuccess: "操作成功！"
        },
        rules: {
            usernameRequired: "请输入用户名",
            usernameEmail: "请输入有效的邮箱地址",
            passwordRequired: "请输入密码",
            passwordPattern: "密码必须包含大小写字母、数字和特殊字符，且长度为8-18个字符",
            authRequired: "请选择权限"
        }
    },
    UserList: {
        pageTitle: "用户列表",
        createUser: "创建用户",
        search: "搜索",
        clear: "清空",
        download: "下载",
        cancel: "取消",
        submit: "提交",
        downloadStart: "开始下载",
        noData: "没有数据可下载",
        downloading: "下载中...",
        createSuccess: "用户创建成功",
        createFail: "用户创建失败",
        account: "会员账号",
        username: "用户名",
        name: "姓名",
        birth: "生日",
        email: "邮箱",
        contact: "联系方式",
        status: "状态",
        normal: "正常",
        blocked: "已封禁",
        lastLogin: "最后登录",
        createTime: "创建时间",
        creator: "创建人",
        balance: "余额",
        remark: "备注",
        userDetails: "用户详情",
        view: "查看",
        startDate: "开始日期",
        endDate: "结束日期",
        password: "密码",
        accountRequired: "请输入会员账号",
        passwordRequired: "请输入密码",
        birthPlaceholder: "请选择生日"
    },

    MemberUsersMore: {
        more: "用户详情",
        modifyUser: "修改用户信息",
        copyUserInfo: "复制用户信息",
        userDetails: "用户信息",
        walletRecords: "钱包交易记录",
        userID: "会员账号",
        downloadUrl: "下载地址",
        memberAccount: "会员账号",
        password: "密码",
        name: "姓名",
        username: "用户名",
        birth: "生日",
        email: "邮箱",
        contact: "联系方式",
        creator_name: "创建人",
        balance: "余额",
        blockStatus: "封禁状态",
        freezeStatus: "冻结状态",
        associateAccount: "关联账户",
        remark: "备注",
        lastLoginTime: "最后登录",
        createTime: "创建时间",
        normal: "正常",
        blocked: "已封禁",
        frozen: "已冻结",
        freeze: "冻结",
        unfreeze: "解冻",
        unblockUser: "解封用户",
        unblock: "解封用户",
        yes: "是",
        no: "否",
        setAssociateAccount: "设置关联账户",
        cancelAssociateAccount: "取消关联账户",
        modifyRemark: "修改备注",
        tip: "提示",
        confirm: "确认",
        cancel: "取消",
        operateSuccess: "操作成功",
        walletCreateTime: "创建时间",
        walletAmount: "金额",
        walletPoints: "积分",
        walletProof: "凭据",
        walletOperator: "操作人",
        manualDeposit: '手动充值',
        manualDeduct: '手动扣除',
        amount: '金额',
        points: '积分',
        proof: '凭证',
        deductType: '扣除类型',
        deductType2: '后台扣除',
        deductType3: '后台扣除餐饮费用',
        operateFail: '操作失败',
        reserveRecords: "预约记录",
        reserveId: "预约ID",
        reserveType: "类型",
        reserveName: "名称",
        reserveCover: "封面",
        reserveStatus: "状态",
        reserveCreateTime: "预约时间",
        reserveUpdateTime: "取消时间",
        typeRoom: "房间",
        typeActivity: "活动",
        typeDining: "餐饮",
        typeView: "约看",
        statusValid: "有效",
        statusCancel: "已取消",
        statusExpired: "已截止或下架",
        action: "操作",
        viewDetail: "查看详情",
        reserveDetailTitle: "预约详情",
        peopleNumber: "人数",
        reserveDate: "预约日期",
        reserveTime: "预约时间",
        pointsNumber: "积分",
        location: "门店",
        productPrice: "产品价格",
        productColor: "产品颜色",
        productMaterial: "产品材料",
        close: "关闭",
        proofRequired: "请至少上传一张凭证",
        amountRequired: "请输入金额",
        pointsRequired: "请输入积分",
        typeRequired: "请选择扣除类型",
        timeRequired: "请选择日期时间",
        Required: '选择日期时间',
    },
    copy: {
        success: "复制成功！",
        fail: "复制失败，请手动复制",
    },
    reminder: {
        PleaseEnter: '请输入',
        PleaseUpload: '请上传',
        PleaseSelect: '请选择',
        MustBeGreaterThanZero: '报名人数须大于0',
    },
};